import { Button } from '@picsart/design-system/components/Button';
import { IllustrationNoResultFound } from '@picsart/design-system/foundation/illustrations/IllustrationNoResultFound';
import { useTranslator } from '@picsart/rc/services/localization';

import useStyles from './styles';
import type { SearchEmptyProps } from './types';

/**
 * No-results / error state, following the search miniapp's `Empty`: an
 * illustration plus a two-line explanation, rather than a bare line of text.
 *
 * `isCompact` drops the illustration for the desktop dropdown, where a full
 * illustration would dwarf the popover.
 */
const SearchEmpty = ({
  title,
  description,
  isCompact,
  onRetry,
}: SearchEmptyProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  return (
    <div className={classes.root} data-testid="search-empty">
      {!isCompact && (
        <IllustrationNoResultFound className={classes.illustration} />
      )}
      <span className={classes.title}>{title}</span>
      {description && (
        <span className={classes.description}>{description}</span>
      )}
      {onRetry && (
        <Button
          variant="outlined"
          skin="primary"
          size="small"
          className={classes.retryButton}
          onClick={onRetry}
          dataTestId="search-empty-retry"
        >
          {translate('Retry')}
        </Button>
      )}
    </div>
  );
};

export default SearchEmpty;
